
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { UserRoleAssignmentDto_$reflection, RoleDefinition_$reflection } from "../../../Shared/Roles.js";
import { union_type, class_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { RequestedValue$1_$reflection } from "../../../Shared/Shared.js";

export class State extends Record {
    constructor(Roles, Assignments) {
        super();
        this.Roles = Roles;
        this.Assignments = Assignments;
    }
}

export function State_$reflection() {
    return record_type("Settings.Roles.Overview.Types.State", [], State, () => [["Roles", RequestedValue$1_$reflection(list_type(RoleDefinition_$reflection()))], ["Assignments", RequestedValue$1_$reflection(list_type(UserRoleAssignmentDto_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RolesFetched", "AssignmentsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Roles.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(RoleDefinition_$reflection())]], [["Item", list_type(UserRoleAssignmentDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

